<template>
    <!--==========================
        Header
    ============================-->
    <header id="header" :class="{'header-fixed': scrollPosition > 100}">
        <div class="container">

            <div id="logo" class="pull-left">
                <a id="BrandWebsiteLink" href="https://www.bradfordwhite.com/" target="_blank">
                    <img id="BrandLogo" src="@/assets/img/logos/BradfordWhite_Logo.png" />
                </a>
            </div>

            <nav id="nav-menu-container">
                <!--<ul class="nav-menu">
                    <li id="menu_applications">
                        <router-link to="/">Home</router-link>
                    </li>                    
                </ul>-->
            </nav>
            <!-- #nav-menu-container -->
        </div>
    </header>

    <!-- #header -->
</template>
<script>
    export default {
        name: 'app-header',
        data() {
            return {
                scrollPosition: null
            }
        },

        methods: {
            updateScroll() {
                this.scrollPosition = window.pageYOffset
            }
        },

        mounted() {
            window.addEventListener('scroll', this.updateScroll)
        }

    }
</script>
